import React from 'react';
import axios from 'axios';
import i18n from '../../../i18n';
import { ROOT_URL } from 'constants/Config.js';

export const firstLetterToUpper = (str) => str.substring(0, 1).toUpperCase() + str.substring(1);

export const getLotsValues = (t) => [
  t('components.collection.showAllLots'),
  t('components.collection.onlySelectedLots'),
  t('components.collection.withoutLots'),
];

export const getBuildingType = (type) => {
  if (type === 2) {
    return i18n.t('common.kp');
  }

  return i18n.t('common.jk');
};

export const SectionsMap = {
  nameAddress: 'nameAddress',
  description: 'description',
  characteristics: 'characteristics',
  communications: 'communications',
  checkout: 'checkout',
  payment: 'payment',
  map: 'map',
  lots: 'lots',
  withoutLots: 'withoutLots',
  allLots: 'allLots',
  selectedLots: 'selectedLots',
};

export const makeBase64 = async (data) => {
  const { values, ...rest } = data;
  const keys = Object.keys(values).filter((key) => !values[key] || key === 'lots');
  const lotsValues = getLotsValues(i18n.t);

  const obj = {
    ...rest,
  };

  keys.forEach((key) => {
    const index = SectionsMap[key];

    if (index === 'lots') {
      switch (values[index]) {
        case lotsValues[0]: {
          obj.selectedLots = 1;
          obj.withoutLots = 1;
          break;
        }
        case lotsValues[1]: {
          obj.allLots = 1;
          obj.withoutLots = 1;
          break;
        }
        case lotsValues[2]: {
          obj.allLots = 1;
          obj.selectedLots = 1;
          break;
        }
        case false: {
          obj[index] = 1;
          break;
        }
      }
    } else {
      obj[index] = 1;
    }
  });

  const response = await axios.post(`${ROOT_URL}/selection/short/link`, { data: obj });

  return response.data.data.hash;
};

const paramsCache = {};
export const getParams = async (hash) => {
  const response = await axios.get(`${ROOT_URL}/selection/short/link?hash=${hash}`);

  if (response.data.data.resp) {
    paramsCache[hash] = response.data.data.resp;
  }

  return paramsCache[hash] || {};
};

const getDataByHash = () => {
  const [, , base64] = window.location.pathname.split('/');
  return paramsCache[base64] || {};
};

export const isSectionAllowed = (sectionName) => {
  if (['/ncollection/', '/nbref/'].findIndex((url) => location.pathname.includes(url)) === -1) {
    return true;
  }

  let innerSectionName = sectionName;
  const data = getDataByHash();

  if (sectionName === 'map' && location.pathname.includes('/nbref/')) {
    /*
      Для старых ссылок у тех, кто не обновил андроид и айос клиента
      Нужно удалить следующий if при следующем редактировании функции
     */
    if (data.map) {
      return false;
    }

    // В шаринге объекта за карту отвечает nameAddress
    innerSectionName = 'nameAddress';
  }

  const isHided = data[innerSectionName] == 1 || false;
  return !isHided;
};

export const ALL_LOTS = 2;
export const SELECTED_LOTS = 1;
export const WITHOUT_LOTS = 0;

export const getLotsType = () => {
  if (['/ncollection/', '/nbref/'].findIndex((url) => location.pathname.includes(url)) === -1) {
    return ALL_LOTS;
  }

  if (location.pathname.includes('nbref')) {
    return isSectionAllowed('lots') ? ALL_LOTS : WITHOUT_LOTS;
  }

  if (isSectionAllowed('withoutLots')) {
    return WITHOUT_LOTS;
  }

  if (isSectionAllowed('selectedLots')) {
    return SELECTED_LOTS;
  }

  return ALL_LOTS;
};

export const linkifyText = (text, maxLength) => {
  const regex =
    /((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})|(\n+|(?:(?!(?:https?:\/\/|ftp:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,}).)+)/gim;
  const message = [];
  let totalLength = 0;

  text.replace(regex, (match, link, plainText) => {
    if (totalLength >= maxLength) {
      return;
    }

    if (link) {
      const href = link.startsWith('www.') ? `//${link}` : link;
      const linkLength = link.length;
      if (totalLength + linkLength > maxLength) {
        message.push('…');
        totalLength = maxLength;
        return;
      }
      message.push(
        <a key={message.length} target="_blank" rel="noopener noreferrer" href={href}>
          {link}
        </a>
      );
      totalLength += linkLength;
    } else if (plainText) {
      const remainingLength = maxLength - totalLength;
      if (plainText.length > remainingLength) {
        message.push(plainText.slice(0, remainingLength));
        message.push('…');
        totalLength = maxLength;
      } else {
        message.push(plainText);
        totalLength += plainText.length;
      }
    }
  });

  return message;
};



// WEBPACK FOOTER //
// ./src/components/Building/Main/helper.js